export enum SIDEBAR_ANIMATION_STEPS {
  DEFAULT = 'DEFAULT',
  SHOW = 'SHOW',
  HIDE = 'HIDE',
  PROFILE_CREATION = 'PROFILE_CREATION',
}
